const POLL_TYPE = "wix-draft-plugin-poll";
export {
  POLL_TYPE
};
//# sourceMappingURL=types.js.map
